// The reader's moves in the opening that gave up at least
// `OPENING_SLIP_PAWNS` against the engine's move: the score before the move
// (the best line's) against the score after it, from the reader's side. A
// move the engine would have played is never a slip. Each keeps the position
// and the moves that led to it, so the same habit can be found across games.
import { OPENING_SLIP_PAWNS, type GameFacts, type OpeningSlip } from '@chess/api-model';
import { type FactExtractor, type ScannedGame } from '../extractor.ts';

export const openingSlips: FactExtractor = {
  id: 'opening-slips',
  extract(game: ScannedGame, facts: GameFacts): void {
    const { fromPly, toPly } = game.range('opening');
    const out: OpeningSlip[] = [];
    for (let ply = fromPly + 1; ply <= toPly; ply++) {
      const move = game.moves[ply - 1];
      if (!move || !game.isReaders(ply)) continue;
      const position = game.at(ply - 1);
      const best = position?.lines[0];
      const before = game.pawnsAt(ply - 1);
      const after = game.pawnsAt(ply);
      if (!position || !best || best.uci === move.uci || before === undefined || after === undefined) continue;
      if (before - after < OPENING_SLIP_PAWNS) continue;
      out.push({
        ply,
        san: move.san,
        uci: move.uci,
        fen: position.fen,
        line: game.moves.slice(0, ply - 1).map((m) => m.san),
        best: best.uci,
        before,
        after,
      });
    }
    facts.openingSlips = out;
  },
};
